<script lang="ts">
    import {
        getAvailableProductText,
        getNotAvailable,
    } from '../../helpers/common';

    import language from '../../lang/language';

    import productsStore, { searched } from '../../store/product';
    import service from '../../store/service';
    import CardSkeleton from '../services/CardSkeleton.svelte';
    import ProductCard from './ProductCard.svelte';

    let products: any = productsStore.data;
    let isLoading = productsStore.data.isLoading;

    export let selectedService;

    export let onRequest;
</script>

<div class="service-wrapper mt-4">
    {#if $products}
        {#if $isLoading}
            <CardSkeleton numberOfSkeleton={1} />
        {:else if $searched}
            <p class="priceDetail__ttl">
                {getAvailableProductText(selectedService.Type)}
            </p>
            <div class="dayBox__wrap">
                <ol>
                    {#each $products as service}
                        <ProductCard {service} {onRequest} {selectedService} />
                    {:else}
                        {getNotAvailable(selectedService.Type)}
                    {/each}
                </ol>
            </div>
        {/if}
    {/if}
</div>

<style>
    .subtitle {
        width: 100%;
        border-bottom: 3px solid var(--primary-color);
        padding: 10px 0px;
    }

    .subtitle > h2 {
        position: relative;
        padding-left: 20px;
    }

    .subtitle > h2:before {
        content: '';
        height: 100%;
        width: 10px;
        background: var(--primary-color);
        position: absolute;
        top: 0;
        left: 0;
    }
</style>
